import type { IAgentPosition, IAgentPositionsMap } from '../types';

export const combineAgentPositionsFromClient = (
  clientId: number,
  agentPositions: IAgentPositionsMap,
): IAgentPosition[] | undefined => agentPositions[clientId];

export const combineAvailableAgentPositionsFromClient = (
  clientId: number,
  agentPositions: IAgentPositionsMap,
): IAgentPosition[] =>
  (combineAgentPositionsFromClient(clientId, agentPositions) || []).filter(
    position => position.isActive && !position.isDeleted,
  );
